import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from './store'
import vuetify from '@/plugins/vuetify'

Vue.config.productionTip = false

/**
 * Vuelidate
 */

import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)

/**
 * Crisp
 */

import { CrispChat, CrispConfig } from '@/plugins/crisp'

Vue.use(CrispChat, CrispConfig)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created ()
  {
    this.$store.dispatch('auth/checkLocalUserData')
  }
}).$mount('#app')